import React from 'react';
import { View, Text, Pressable, ScrollView, ActivityIndicator } from '../../lib/react-native-compat';
import { wizardSteps } from './sectionDefs';

// Sticky bottom bar: Back | scrollable step chips | Next — one condensed row
// so it stays short on phones. Chips double as a jump list; the Review chip
// has no number. steps defaults to the full wizard; the Quick Report passes
// its own two-step list.
const WizardNav = ({ step, onStep, saving, dirty, steps = wizardSteps }) => {
    const chip = (s, i) => {
        const active = i === step;
        return (
            <Pressable
                key={s.key}
                onPress={() => onStep(i)}
                style={{
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 999,
                    backgroundColor: active ? '#1D4ED8' : '#F1F5F9',
                    border: active ? '1px solid #1D4ED8' : '1px solid #E2E8F0',
                    marginRight: 4,
                    cursor: 'pointer',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Text style={{ fontSize: 11, fontWeight: '600', color: active ? '#fff' : '#475569', whiteSpace: 'nowrap' }}>
                    {s.key === 'review' ? s.short : `${i + 1}. ${s.short}`}
                </Text>
            </Pressable>
        );
    };

    return (
        <View style={{ position: 'sticky', bottom: 0, backgroundColor: '#ffffff', borderTop: '1px solid #E2E8F0', boxShadow: '0 -2px 8px rgba(15,23,42,0.06)', zIndex: 5, flexDirection: 'row', alignItems: 'center', paddingTop: 6, paddingBottom: 6, paddingLeft: 8, paddingRight: 8, columnGap: 8 }}>
            <Pressable
                onPress={() => step > 0 && onStep(step - 1)}
                style={{ minHeight: 38, minWidth: 62, borderRadius: 8, border: '1px solid #CBD5E1', alignItems: 'center', justifyContent: 'center', backgroundColor: step === 0 ? '#F8FAFC' : '#fff', cursor: step === 0 ? 'default' : 'pointer', flexShrink: 0 }}
            >
                <Text style={{ fontSize: 13, fontWeight: '600', color: step === 0 ? '#CBD5E1' : '#334155' }}>Back</Text>
            </Pressable>
            <ScrollView horizontal style={{ flex: 1, minWidth: 0 }} contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }} showsHorizontalScrollIndicator={false}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>{steps.map(chip)}</View>
            </ScrollView>
            {(saving || dirty) && (
                <View style={{ flexDirection: 'row', alignItems: 'center', flexShrink: 0 }}>
                    {saving ? <ActivityIndicator size="small" /> : null}
                    <Text style={{ fontSize: 10, color: '#94A3B8', marginLeft: 3 }}>{saving ? 'Saving…' : 'unsaved'}</Text>
                </View>
            )}
            <Pressable
                onPress={() => step < steps.length - 1 && onStep(step + 1)}
                style={{ minHeight: 38, minWidth: 66, borderRadius: 8, alignItems: 'center', justifyContent: 'center', backgroundColor: step >= steps.length - 1 ? '#94A3B8' : '#1D4ED8', cursor: 'pointer', flexShrink: 0 }}
            >
                <Text style={{ fontSize: 13, fontWeight: '600', color: '#fff' }}>Next</Text>
            </Pressable>
        </View>
    );
};

export default WizardNav;
